import html2pdf from "html2pdf.js"
import { servObj } from "./init_glob"
import _Draggable from "gsap/Draggable";

const formatNumber = (number) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

const download_btn = document.getElementById("download_pdf")

const getOrderId = () => {
    const date = new Date().toLocaleDateString()
    const splited = date.split(".")
    return `Заказ №${splited[0]}${splited[1]}${splited[2].replace("20", "")}-${parent.servObj.googleData} от ${date}`
}

const config = {
    margin: [15, 0, 5, 0],
    filename: `777.pdf`,
    jsPDF: {
        unit: "px",
        format: "a4",
        orientation: "portrait",
    },
    html2canvas: {
        scale: 4,
        logging: true,
    },
    pagebreak: {
        after: ".pageBreak",
        before: ".pageBreakBefore",
    },
};



const savePDF = () => {
    const element = document.getElementById("content")
    const table = document.querySelector('table')

    let rows = []
    let breaks = []

    if(parent.servObj.cart && parent.servObj.cart.length){
        

        let totalPrice = 0

        parent.servObj.cart.map((el, i) => {
            console.log(el)
            const newRow = document.createElement('tr')

            const cell1 = document.createElement('td')
            cell1.innerHTML = `<img class="table-img" src="${el.imagePath}"/>`

            const cell2 = document.createElement('td')
            cell2.innerHTML = el.name

            const cell3 = document.createElement('td')
            cell3.textContent = `${el.count} ${el.imagePath.includes("fence") ? "шт" : "м2"}`

            const cell4 = document.createElement('td')
            cell4.textContent = `${el.price} Р`

            newRow.appendChild(cell1)
            newRow.appendChild(cell2)
            newRow.appendChild(cell3)
            newRow.appendChild(cell4)

            const _ = document.createElement('div')
            _.classList.add("spec")
            _.classList.add("first-page-spec")
            _.classList.add("pageBreak")

            if(i == 8){
                table.appendChild(_)
                breaks.push(_)
            }else if((i - 8) % 10 == 0){
                //console.log("HERE")
                table.appendChild(_)
                breaks.push(_)
            }

            table.appendChild(newRow)

            

            
            
            rows.push(newRow)

            totalPrice += el.price
        })

        document.querySelector(".total-price").innerText = `Итого: ${formatNumber(totalPrice)} Р`
    }

    document.querySelector(".order").innerText = getOrderId()

    config.filename = getOrderId().split(" от ")[0] + ".pdf"

    html2pdf()
        .set(config)
        .from(element)
        .toPdf()
        .get("pdf")
        .then(function (pdf) {
            rows.map(r => {
                table.removeChild(r)
            })
            breaks.map(b => table.removeChild(b))
            // const totalPages = pdf.internal.getNumberOfPages();
            // for (let i = 1; i <= totalPages; i++) {
            //     if (i === 1) continue;
            //     pdf.setPage(i);
            //     pdf.setFontSize(12);
            //     pdf.text(`${i}`, pdf.internal.pageSize.getWidth() - 20, pdf.internal.pageSize.getHeight() - 10);
            // }
        })
        .save();
};
download_btn?.addEventListener("click", savePDF);